import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Row,
  Button,
  Spinner,
  Dropdown,
  DropdownButton,
  Accordion,
  Table,
} from "react-bootstrap";
import NoData from "../../components/NoData";
import { FaEdit, FaTrashAlt, FaUserCircle } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import ServiceCategoryModal from "../../components/Modals/ ServiceCategoryModel";
import ServiceSubCategoryModal from "../../components/Modals/ ServiceSubCategoryModel";
import ServiceModal from "../../components/Modals/ServiceModel";
import { BASE_URL, HEADERS } from "../../utils/constant";
import axios from "axios";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import Loader from "../../components/Loader";
import { useCommonContext } from "../../utils/context";

const Services = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showServiceCategoryModal, setShowServiceCategoryModal] =
    useState(false);
  const [showServiceSubCategoryModal, setShowServiceSubCategoryModal] =
    useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [expandedSubServiceId, setExpandedSubServiceId] = useState(null);
  const [currentService, setCurrentService] = useState(null);
  const [currentSubService, setCurrentSubService] = useState(null);
  const userPermissions = localStorage.getItem("user_permissions");
  const [serviceCat, setServiceCat] = useState([]);
  const [subServices, setSubServices] = useState({});
  const [services, setServices] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const { toggled } = useCommonContext();

  useEffect(() => {
    fetchServiceCatData();
    fetchSubServicesData();
  }, []);

  const fetchServiceCatData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/service-categories/?page_size=all`,
        {
          headers: HEADERS,
        },
      );
      setServiceCat(response.data.results || []);
    } catch (error) {
      // toast.error("Error fetching service categories.");
    } finally {
      setLoading(false);
    }
  };

  const fetchSubServicesData = async (serviceCategoryId, page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/service-sub-categories/?service_category=${serviceCategoryId}&page_size=all`,
        { headers: HEADERS },
      );
      setSubServices((prevSubServices) => ({
        ...prevSubServices,
        [serviceCategoryId]: response.data.results,
      }));
    } catch (error) {
      // toast.error("Error fetching sub-services.");
    } finally {
      setLoading(false);
    }
  };

  const handleServiceClick = (id) => {
    setSelectedServiceId(id);

    fetchSubServicesData(id);
  };

  const handleSubServiceClick = (subServiceId) => {
    setExpandedSubServiceId(
      expandedSubServiceId === subServiceId ? null : subServiceId,
    );
    if (!services[subServiceId]) {
      fetchServicesData(subServiceId);
    }
  };

  const handleEditServiceCategory = (service) => {
    setCurrentService(service);
    setShowServiceCategoryModal(true);
  };

  const handleDeleteServiceCategory = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/service-categories/${id}/`, {
        headers: HEADERS,
      });
      toast.success("Service Category deleted successfully");
      fetchServiceCatData();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);

        toast.error("Error Please Try again.");
      }
    }
  };

  const fetchServicesData = async (subServiceCategoryId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/services/?service_sub_category=${subServiceCategoryId}&?page_size=all`,
        {
          headers: HEADERS,
        },
      );
      setServices((prevServices) => ({
        ...prevServices,
        [subServiceCategoryId]: response.data.results,
      }));
    } catch (error) {}
  };

  const handleEditSubService = (subService) => {
    setCurrentSubService(subService);
    setShowServiceSubCategoryModal(true);
  };

  const handleEditService = (services) => {
    setCurrentService(services);
    setShowServiceModal(true);
  };

  const handleDeleteSubService = async (id, serviceCategoryId) => {
    try {
      await axios.delete(`${BASE_URL}/api/service-sub-categories/${id}/`, {
        headers: HEADERS,
      });
      toast.success("Sub-Service deleted successfully");
      fetchSubServicesData(serviceCategoryId);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);

        toast.error("Error Please Try again.");
      }
    }
  };

  const handleDeleteService = async (id, subServiceCategoryId) => {
    try {
      await axios.delete(`${BASE_URL}/api/services/${id}/`, {
        headers: HEADERS,
      });
      toast.success("Service deleted successfully");
      fetchServicesData(subServiceCategoryId);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);

        toast.error("Error Please Try again.");
      }
    }
  };

  const handleCloseServiceCategoryModal = () => {
    setShowServiceCategoryModal(false);
    setCurrentService(null);
    fetchServiceCatData();
  };

  const handleCloseServiceSubCategoryModal = () => {
    setShowServiceSubCategoryModal(false);
    setCurrentSubService(null);
    fetchSubServicesData(selectedServiceId);
  };

  const handleCloseServiceModal = () => {
    setShowServiceModal(false);
    setCurrentService(null);
    fetchServicesData(expandedSubServiceId);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredServiceCat = serviceCat.filter(
    (service) =>
      service.service_category_name
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      service.id?.toString().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="container-fluid ">
      {loading ? (
        <Loader />
      ) : (
        <Row className="mt-3">
          <Col xs={12} sm={6} lg={3} className="mb-3">
            <Card className="w-100  border-0 rounded-lg">
              <Card.Header className="bg-primary text-white border-bottom-0 rounded-top">
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <span className="fs-5 fw-semibold mb-2 mb-sm-0 me-4">
                    Service Category
                  </span>
                  {/* <input
                   type="text"
                   className="form-control w-100 w-sm-auto"
                   value={searchText}
                   placeholder="Search Here..."
                   onChange={(e) => setSearchText(e.target.value)}
                 /> */}
                </div>
              </Card.Header>
              <Card.Body
                className="overflow-auto"
                style={{
                  maxHeight: "700px",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                }}
              >
                {filteredServiceCat.length > 0 ? (
                  filteredServiceCat.map((service) => (
                    <Card
                      key={service.id}
                      className={`user-item mb-3 border-0 shadow-sm p-2 rounded-3 
                  d-flex  justify-content-between
                  ${
                    selectedServiceId === service.id
                      ? "border border-primary bg-primary bg-opacity-10 text-primary shadow-sm"
                      : "bg-white text-dark"
                  } 
                  transition-all`}
                      onClick={() => handleServiceClick(service.id)}
                      style={{
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                      }}
                    >
                      <Card.Body className="d-flex  gap-3 p-2">
                        <div className="flex-shrink-0">
                          {service.service_cat_image ? (
                            <img
                              src={service.service_cat_image}
                              alt="Service"
                              className="rounded-circle border"
                              style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <FaUserCircle
                              size={35}
                              className="text-secondary"
                            />
                          )}
                        </div>

                        <div className="flex-grow-1 overflow-hidden">
                          <h6
                            className="mb-0  text-truncate"
                            style={{ maxWidth: "130px" }}
                            title={
                              service.service_category_name ||
                              "No Name Available"
                            }
                          >
                            {service.service_category_name}
                          </h6>
                          <small
                            className="text-muted d-block text-truncate"
                            style={{ maxWidth: "130px" }}
                          >
                            {service.service_cat_descriptions}
                          </small>
                        </div>
                        <span
                          className="badge d-flex align-items-center justify-content-center 
                         bg-secondary text-white flex-shrink-0"
                          style={{
                            minWidth: "40px",
                            height: "25px",
                            fontSize: "14px",
                            borderRadius: "12px",
                          }}
                        >
                          {service.id}
                        </span>
                      </Card.Body>
                    </Card>
                  ))
                ) : (
                  <NoData message="No Data Found" height="400px" />
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col md={9}>
            <Card className="shadow-sm mb-2">
              <Card.Body>
                <Row className="d-flex justify-content-between align-items-center mb-3">
                  <Col>
                    <h5 className="card-title text-start">
                      Service Sub Category
                    </h5>
                  </Col>
                  <Col className="d-flex justify-content-end align-items-center gap-2">
                    {userPermissions.includes(
                      "servicecategory_add_servicecategory",
                    ) && (
                      <Button
                        variant="primary"
                        onClick={() => setShowServiceCategoryModal(true)}
                        size="sm"
                      >
                        Add Service Category
                      </Button>
                    )}
                    <Button
                      variant="primary"
                      onClick={() => setShowServiceSubCategoryModal(true)}
                      size="sm"
                    >
                      Add Service Sub Category
                    </Button>
                  </Col>
                </Row>
                <div style={{ height: "67vh", overflowY: "scroll" }}>
                  {selectedServiceId ? (
                    subServices[selectedServiceId]?.length > 0 ? (
                      subServices[selectedServiceId].map((subService) => (
                        <Accordion
                          key={subService.id}
                          activeKey={
                            expandedSubServiceId === subService.id
                              ? `${subService.id}`
                              : null
                          }
                          flush
                        >
                          <Accordion.Item eventKey={`${subService.id}`}>
                            <Accordion.Header
                              onClick={() =>
                                handleSubServiceClick(subService.id)
                              }
                              className="d-flex justify-content-between align-items-center"
                            >
                              <div className="d-flex align-items-center w-100">
                                <img
                                  src={
                                    subService.service_sub_image ||
                                    "https://via.placeholder.com/50"
                                  }
                                  alt="Sub Service Icon"
                                  className="rounded-circle border me-2"
                                  style={{ width: "40px", height: "40px" }}
                                />
                                <div className="service-details flex-grow-1 ms-2">
                                  <div className="d-flex align-items-center mb-1">
                                    <span className="service-id badge bg-primary text-white me-2">
                                      {subService.id}
                                    </span>
                                    <span className="service-name fw-bold">
                                      {subService.service_sub_category_name}
                                    </span>
                                  </div>
                                </div>
                                <DropdownButton
                                  id={`dropdown-${subService.id}`}
                                  title={<BsThreeDotsVertical />}
                                  variant="link"
                                  className="text-secondary custom-dropdown"
                                >
                                  <Dropdown.Item
                                    onClick={() =>
                                      handleEditSubService(subService)
                                    }
                                  >
                                    <FaEdit className="me-2" /> Edit
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() =>
                                      handleDeleteSubService(
                                        subService.id,
                                        selectedServiceId,
                                      )
                                    }
                                  >
                                    <FaTrashAlt className="me-2" /> Delete
                                  </Dropdown.Item>
                                </DropdownButton>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <Row className="mb-3">
                                <Col className="d-flex justify-content-end">
                                  <Button
                                    variant="primary"
                                    onClick={() => setShowServiceModal(true)}
                                    size="sm"
                                  >
                                    Add Service
                                  </Button>
                                </Col>
                              </Row>

                              {services[subService.id]?.length > 0 ? (
                                <table className="table table-bordered  tstart">
                                  <thead className="thead">
                                    <tr style={{ whiteSpace: "nowrap" }}>
                                      <th style={{ width: "300px" }}>
                                        Service Name
                                      </th>
                                      <th style={{ width: "150px" }}>
                                        Service Estimate
                                      </th>
                                      <th style={{ width: "200px" }}>
                                        Service Contact Number
                                      </th>
                                      <th style={{ width: "450px" }}>
                                        Service Description
                                      </th>
                                      <th style={{ width: "100px" }}></th>
                                    </tr>
                                  </thead>
                                  <tbody className="tbody">
                                    {services[subService.id].map(
                                      (serviceSub) => (
                                        <tr key={serviceSub.id}>
                                          <td>
                                            <div className="d-flex align-items-center">
                                              <img
                                                src={
                                                  serviceSub.service_image1 ||
                                                  "https://via.placeholder.com/50"
                                                }
                                                alt="Service Icon"
                                                className="rounded-circle border me-2"
                                                style={{
                                                  width: "30px",
                                                  height: "30px",
                                                }}
                                              />
                                              <span className="service-id badge bg-primary text-white me-2">
                                                {serviceSub.id}
                                              </span>
                                              <div
                                                title={
                                                  serviceSub.service_name || "—"
                                                }
                                                className="tdsubject"
                                              >
                                                {serviceSub.service_name || "—"}
                                              </div>
                                            </div>
                                          </td>

                                          <td>
                                            <div
                                              title={
                                                serviceSub?.service_price || "—"
                                              }
                                              className="tdsubject"
                                            >
                                              {serviceSub?.service_price || "—"}
                                            </div>
                                          </td>
                                          <td>
                                            <div
                                              title={
                                                serviceSub?.service_contact_number ||
                                                "—"
                                              }
                                              className="tdsubject"
                                            >
                                              {serviceSub?.service_contact_number ||
                                                "—"}
                                            </div>
                                          </td>

                                          <td>
                                            <div
                                              title={
                                                serviceSub.service_description ||
                                                "—"
                                              }
                                              className="tdsubject"
                                            >
                                              {serviceSub.service_description ||
                                                "—"}
                                            </div>
                                          </td>
                                          <td>
                                            <DropdownButton
                                              id={`dropdown-service-${serviceSub.id}`}
                                              title={<BsThreeDotsVertical />}
                                              variant="link"
                                              className="text-secondary custom-dropdown"
                                            >
                                              <Dropdown.Item
                                                onClick={() =>
                                                  handleEditService(serviceSub)
                                                }
                                              >
                                                <FaEdit className="me-2" /> Edit
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                onClick={() =>
                                                  handleDeleteService(
                                                    serviceSub.id,
                                                    subService.id,
                                                  )
                                                }
                                              >
                                                <FaTrashAlt className="me-2" />{" "}
                                                Delete
                                              </Dropdown.Item>
                                            </DropdownButton>
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              ) : (
                                <NoData
                                  message="No Data Found"
                                  height="400px"
                                />
                              )}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))
                    ) : (
                      <div className="text-center">
                        <p className="text-muted fs-4">
                          No Sub Services Found for this Service.
                        </p>
                      </div>
                    )
                  ) : (
                    <div className="text-center">
                      <NoData
                        message="Select a Service Category to see Sub Categories"
                        height="400px"
                      />
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {showServiceCategoryModal && (
        <ServiceCategoryModal
          show={showServiceCategoryModal}
          handleClose={handleCloseServiceCategoryModal}
          service={currentService}
          serviceCat={serviceCat}
          fetchServiceCatData={fetchServiceCatData}
        />
      )}
      {showServiceSubCategoryModal && (
        <ServiceSubCategoryModal
          show={showServiceSubCategoryModal}
          handleClose={handleCloseServiceSubCategoryModal}
          currentSubService={currentSubService}
          serviceCat={serviceCat}
          fetchSubServicesData={fetchSubServicesData}
        />
      )}
      {showServiceModal && (
        <ServiceModal
          show={showServiceModal}
          handleClose={handleCloseServiceModal}
          currentService={currentService}
          suballServices={subServices[selectedServiceId] || []}
          fetchServicesData={fetchServicesData}
        />
      )}
    </div>
  );
};

export default Services;
